// removed by extract-text-webpack-plugin
module.exports = {"container":"AppMainPage__container-3OZx1","header":"AppMainPage__header-3HUbU","app":"AppMainPage__app-32gWx"};